import { FC } from "react";
import { Field, useFormikContext } from "formik";
import { ChargebackWorkPacket } from "src/types/work-packets.ts";
import { CurrencyField } from "src/components/UI/Form/CurrencyField";
import { FormFieldsGroup } from "src/pages/UserDashboard/WorkPackets/WorkPacketDetailsPopup/Summary/components";
import { TextField } from "@mui/material";
import { AutocompleteField, DatePickerField } from "components/UI/Form";
import { chargebackEscalationWorkPacketActions } from "src/pages/UserDashboard/WorkPackets/WorkPacketsGrid/helpers/getStaticFilterOptions.ts";
import { createFieldFn } from "src/pages/UserDashboard/WorkPackets/WorkPacketDetailsPopup/Summary/field-util.ts";

const getField = createFieldFn<ChargebackWorkPacket>();

export const Escalations: FC = () => {
  const { values: packet } = useFormikContext<ChargebackWorkPacket>();
  return packet.escalations.map((escalation, i) => (
    <FormFieldsGroup title={`Escalation ${i + 1}`} withDivider id={`escalation-${i + 1}`} key={escalation.id}>
      <Field
        name={getField(`escalations[${i}].id`)}
        as={TextField}
        variant="outlined"
        size="small"
        label="Chargeback Issue ID"
        disabled
      />

      {/*<Field*/}
      {/*  name={getField(`escalations[${i}].createdAt`)}*/}
      {/*  component={DatePickerField}*/}
      {/*  label="Case Created Date"*/}
      {/*  disabled*/}
      {/*/>*/}

      <Field
        name={getField(`escalations[${i}].status`)}
        component={AutocompleteField}
        label="Case Item Status"
        options={chargebackEscalationWorkPacketActions}
        getOptionLabel={(option: any) => option.title}
      />

      <Field
        name={getField(`escalations[${i}].disputedAmount`)}
        component={CurrencyField}
        variant="outlined"
        size="small"
        label="Disputed Amount"
        disabled
      />
      <Field
        name={getField(`escalations[${i}].approvedAmount`)}
        component={CurrencyField}
        variant="outlined"
        size="small"
        label="Approved Amount"
      />

      <Field
        name={getField(`escalations[${i}].approvedDate`)}
        component={DatePickerField}
        label="Approved Date in Case"
      />

      <Field
        name={getField(`escalations[${i}].paidAmount`)}
        component={CurrencyField}
        variant="outlined"
        size="small"
        label="Paid Amount"
        disabled
      />
    </FormFieldsGroup>
  ));
};
